// @ts-strict-ignore
import {AttrsSchema, Component} from 'panel';

import * as Focusable from 'common/util/focusable';

export interface BaseButtonAttrs {
  disabled?: boolean;
  elref?: string;
  'not-focusable'?: boolean;
  readonly?: boolean;
  'style-override'?: string;
}

export const baseButtonParams = {
  disabled: Boolean,
  elref: String,
  'not-focusable': Boolean,
  readonly: Boolean,
  'style-override': String,
};

export class ButtonBase<AttrsT, ParamT = unknown, ContextRegistryT = unknown> extends Component<
  EmptyObj,
  BaseButtonAttrs & AttrsT,
  unknown,
  unknown,
  ContextRegistryT,
  ParamT
> {
  static get attrsSchema(): AttrsSchema<BaseButtonAttrs> {
    return {
      ...super.attrsSchema,
      disabled: `boolean`,
      elref: `string`,
      'not-focusable': `boolean`,
      readonly: `boolean`,
    };
  }

  get config() {
    return {
      defaultState: {},
      template: () => null,
      useShadowDom: true,
      helpers: {},
    };
  }

  get disabled() {
    return this.attr(`disabled`);
  }

  set disabled(disabled) {
    if (disabled) {
      this.setAttribute(`disabled`, ``);
    } else {
      this.removeAttribute(`disabled`);
    }
  }

  attributeChangedCallback(attr, oldValue, newValue) {
    super.attributeChangedCallback(attr, oldValue, newValue);
    Focusable.handleAttributeChangedCallback(this, attr);
  }

  connectedCallback() {
    super.connectedCallback();
    this.setAttribute(`role`, `button`);

    Focusable.handleConnectedCallback(this);
  }

  disconnectedCallback() {
    Focusable.handleDisconnectedCallback(this);
    super.disconnectedCallback();
  }
}
